import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';


import UploadStoreLogo from './UploadStoreLogo';
import PaymentTerms from './PaymentTerms';
import PaymentMethods from './PaymentMethods';
import TaxSettings from './TaxSettings';

import { updateSettings } from '../../redux/actions/settings';

import { locationsIndex } from '../../redux/actions/locations';

import NewTaxSettingModal from './modals/NewTaxSettingModal';
import NewPaymentTermModal from './modals/NewPaymentTermModal';
import NewPaymentMethodModal from './modals/NewPaymentMethodModal';

import EditTaxSettingModal from './modals/EditTaxSettingModal';
import EditPaymentTermModal from './modals/EditPaymentTermModal';
import EditPaymentMethodModal from './modals/EditPaymentMethodModal';

import DisableTaxSettingModal from './modals/DisableTaxSettingModal';
import DisablePaymentTermModal from './modals/DisablePaymentTermModal';
import DisablePaymentMethodModal from './modals/DisablePaymentMethodModal';


const Settings = ({ payload, settings, submitSettings, locations, loadLocations }) => {
  const [submitted, setSubmitted] = useState(false);

  const [pageSize, setPageSize] = useState(settings.settings.page_size);
  const [authorizationLine, setAuthorizationLine] = useState(settings.settings.authorization_line);

  const [orderMultiples, setOrderMultiples] = useState(settings.settings['order_multiples']);
  const [packQuantities, setPackQuantities] = useState(settings.settings['pack_quantities']);
  const [warningsBlock, setWarningsBlock] = useState(settings.settings['warnings_block']);
  const [taxColumn, setTaxColumn] = useState( ((settings.settings['tax_column'] === undefined || settings.settings['tax_column'] === null)) ? true : settings.settings['tax_column']);

  const [pdfCorporateAddress, setPdfCorporateAddress] = useState(null);
  const [pdfCorporateEmail, setPdfCorporateEmail] = useState(settings.settings.pdf_corporate_email);
  const [pdfCorporatePhone, setPdfCorporatePhone] = useState(settings.settings.pdf_corporate_phone);

  const [showNewTaxSettingModal, setShowNewTaxSettingModal] = useState(false);
  const [showNewPaymentTermModal, setShowNewPaymentTermModal] = useState(false);
  const [showNewPaymentMethodModal, setShowNewPaymentMethodModal] = useState(false);

  const [showEditTaxSettingModal, setShowEditTaxSettingModal] = useState(false);
  const [showEditPaymentTermModal, setShowEditPaymentTermModal] = useState(false);
  const [showEditPaymentMethodModal, setShowEditPaymentMethodModal] = useState(false);

  const [showDisableTaxSettingModal, setShowDisableTaxSettingModal] = useState(false);
  const [showDisablePaymentTermModal, setShowDisablePaymentTermModal] = useState(false);
  const [showDisablePaymentMethodModal, setShowDisablePaymentMethodModal] = useState(false);

  const [activeTaxSetting, setActiveTaxSetting] = useState(null);
  const [activePaymentTerm, setActivePaymentTerm] = useState(null);
  const [activePaymentMethod, setActivePaymentMethod] = useState(null);

  const [invoiceNumberOverride, setInvoiceNumberOverride] = useState(settings.settings.invoice_number_override);
  const [purchaseOrderNumberOverride, setPurchaseOrderNumberOverride] = useState(settings.settings.purchase_order_number_override);

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  useEffect(() => {
    loadLocations(payload);
  }, []);

  useEffect(() => {
    if(!locations.isFetching && locations.status === 'success') {
      let currentAddress = locations.locations.find(location => location.id === settings.settings.pdf_corporate_address_id);

      setPdfCorporateAddress(currentAddress?.id || null);

      console.log(currentAddress);

    }
  }, [locations]);

  useEffect(() => {
    if(!settings.isFetching && settings.status === 'success') {
      setSubmitted(false);
    };
  }, [settings])

  const setSize = (event) => {
    let size = event.target.value;
    setPageSize(size);
  }

  const validateEmail = (event) => {
    let value = event.target.value;
    setPdfCorporateEmail(value);
  }
  
  const validatePhone = (event) => {
    let value = event.target.value;
    setPdfCorporatePhone(value);
  }

  const validateInvoiceOverride = (event) => {
    let value = event.target.value;
    if(value?.length > 0) {
      setInvoiceNumberOverride(value);
    } else {
      setInvoiceNumberOverride(null);
    }
  }

  const validatePurchaseOrderOverride = (event) => {
    let value = event.target.value;
    if(value?.length > 0) {
      setPurchaseOrderNumberOverride(value);
    } else {
      setPurchaseOrderNumberOverride(null);
    }
  }

  const handleAuthLine = () => {
    setAuthorizationLine(!authorizationLine);
  }

  const handleOrderMultiples = () => {
    setOrderMultiples(!orderMultiples);
  }

  const handlePackQuantities = () => {
    setPackQuantities(!packQuantities);
  }

  const handleWarningsBlock = () => {
    setWarningsBlock(!warningsBlock);
  }

  const handleTaxColumn = () => {
    setTaxColumn(!taxColumn);
  }

  const newSettingsJson = () => {
    return {
      page_size: pageSize,
      logo_location: settings?.settings?.logo_location,
      authorization_line: authorizationLine,
      pdf_corporate_address_id: pdfCorporateAddress,
      pdf_corporate_email: pdfCorporateEmail,
      pdf_corporate_phone: pdfCorporatePhone,
      invoice_number_override: invoiceNumberOverride,
      purchase_order_number_override: purchaseOrderNumberOverride,
      order_multiples: orderMultiples,
      pack_quantities: packQuantities,
      warnings_block: warningsBlock,
      tax_column: taxColumn,
    }
  }

  const submit = () => {
    setSubmitted(true);
    submitSettings(payload, newSettingsJson());
  }

  return(
    <>
      <PageHeader stripeBackground='#943737' helpLink="ecwid/supplier-purchase-orders-app-settings-2/" />


      <div className="settings-page cf">
        <div className="settings-page__header">

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Logo</div>
              </div>
              <div className="named-area__description">
                <p>Upload a logo by choosing a file and clicking the "Upload Logo" button. This is the logo that is used at the top left of your PDFs for purchase orders, shipment lists and warehouse receiving orders.</p>
                <p>Payment terms, payment methods and tax settings can be managed in their respective panels. These options will be used in dropdown options for suppliers and purchase orders. The tax rate setting will be used as a percentage in purchase orders when no adjustment is provided.</p>
              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">
                <UploadStoreLogo 
                  payload={payload}
                />
              </div>
            </div>
          </div>

          <PaymentTerms 
            payload={payload}
            setActivePaymentTerm={setActivePaymentTerm}
            setShowNewPaymentTermModal={setShowNewPaymentTermModal}
            setShowEditPaymentTermModal={setShowEditPaymentTermModal}
            setShowDisablePaymentTermModal={setShowDisablePaymentTermModal}
          />

          <PaymentMethods 
            payload={payload} 
            setActivePaymentMethod={setActivePaymentMethod}
            setShowNewPaymentMethodModal={setShowNewPaymentMethodModal}
            setShowEditPaymentMethodModal={setShowEditPaymentMethodModal}
            setShowDisablePaymentMethodModal={setShowDisablePaymentMethodModal}
          />

          <TaxSettings 
            payload={payload} 
            setActiveTaxSetting={setActiveTaxSetting}
            setShowNewTaxSettingModal={setShowNewTaxSettingModal}
            setShowEditTaxSettingModal={setShowEditTaxSettingModal}
            setShowDisableTaxSettingModal={setShowDisableTaxSettingModal}
          />


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Product Assignment Options</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="status-block__primary-action">

                      { !submitted && <button className="btn btn-primary btn-medium" onClick={() => submit()}>Save Settings</button> }
                      { submitted && <button className="btn btn-primary btn-medium btn-loading" disabled /> }

                    </div>
                  </div>
                </div>

                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">
                    <h4>Order Multiples</h4>
                    <p>Enable this option if you have products that need to be ordered in specific multiples. For example, enable this option if an item in your store can only be ordered from a supplier in sets of 3, and you need to be warned when the quantity of that item in a Purchase Order form is not evenly divisible by 3.</p>
                    <p>This option will be available to be set in the Supplier Product Assignment tool, and can be included in a CSV upload by adding a column to a Supplier Product Assignment CSV under a new column with the header "Order Multiple".</p>
                    <hr/>
                    <h5>Enable Order Multiples</h5>
                    <label className="checkbox big">
                      <input type="checkbox" checked={orderMultiples} onClick={() => handleOrderMultiples()}/>
                      <div><div></div></div>
                    </label>
                  </div>
                </div>

                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">
                    <h4>Pack Quantity</h4>
                    <p>Enable this option if you order products in packages that result in multiple inventory units. For example, if you order 100 packs of an item from a supplier, that will be unpacked into 100 separate items, each of which should be considered a seaparate inventory item in your store's inventory.</p>
                    <p>Products that don't have a pack quantity set will be treated as if they have a pack quantity of 1.</p>
                    <p>When suggesting orders, the suggested quantity will be rounded up when a product has low inventory, so that the suggestion will at least match the threshold set in the thresholds tool.</p>
                    <p>Products with pack quantities that are not 1 will not be fulfillable by purchase orders sent directly to customers. This is because the ordered quantity represents a different number of products than the number that would appear in a purchase order to a supplier. In the above example, a customer is ordering 1 item, not a 100 pack of items.</p>
                    <p>This option will be available to be set in the Supplier Product Assignment tool, and can be included in a CSV upload by adding a column to a Supplier Product Assignment CSV under a new column with the header "Pack Quantity".</p>
                    <hr/>
                    <h5>Enable Pack Quantity</h5>
                    <label className="checkbox big">
                      { packQuantities && <input type="checkbox" checked="true" onClick={() => handlePackQuantities()}/>}
                      { !packQuantities && <input type="checkbox" onClick={() => handlePackQuantities()}/>}
                      <div><div></div></div>
                    </label>
                  </div>
                </div>

              </div>
            </div>

          </div>




          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Settings</div>
              </div>
              <div className="named-area__description">
                <p>Select the appropriate page size from either the US Letter or A4 page size radio buttons.</p>
                <p>Select a corporate address to display at the top left of each page in your pucrhase orders, and set a corporate contact email and/or corporate contact phone number to appear below that address.</p>
                <p>When enabled, the "Include Authorization Line" option creates a line for an authorization name/signature to appear at the bottom of purchase orders.</p>
                <p>When you're done updating your settings, click the "Save Page Settings" button to update how purchase order PDFs will be generated.</p>

              </div>
            </div>
            <div className="named-area__body">
              <div className="a-card-stack">

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <div className="status-block__primary-action">

                      { !submitted && <button className="btn btn-primary btn-medium" onClick={() => submit()}>Save Settings</button> }
                      { submitted && <button className="btn btn-primary btn-medium btn-loading" disabled /> }

                    </div>
                  </div>
                </div>

                <div className="a-card a-card--compact">
                  <div className="a-card__paddings">

                    
                        { locations.status !== 'success' &&
                          <div className="a-card a-card--normal">
                            <div className="a-card__paddings">
                              <LoadingSpinner size="xxp" statusText="Loading locations"/>
                            </div>
                          </div>
                        }

                        { locations.status === 'success' && locations.locations.length > 0 &&
                          <div className="a-card a-card--normal">
                            <div className="a-card__paddings">
                              <div className="fieldset fieldset--select">
                                <div className="field field--medium field--filled">
                                  <label className="field__label">Corporate Address</label>
                                  <select onChange={(e) => setPdfCorporateAddress(e.target.value)} className="field__select">
                                    <option hidden disabled selected={pdfCorporateAddress === null} value></option>
                                    { locations.locations.map((location) =>
                                      <option selected={pdfCorporateAddress === location.id} value={location.id} key={location.id}>{location.label}</option>
                                    )}
                                  </select>

                                  <div className="field__placeholder">Corporate Address</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        { locations.status === 'success' && locations.locations.length === 0 &&
                          <div className="a-card a-card--normal a-card--warning">
                            <div className="a-card__paddings">
                              <p>No corporate locations set. Create corporate locations to see them here.</p>
                              <Link to="/locations">
                                <button className="btn btn-default">
                                  Manage locations
                                </button>
                              </Link>
                            </div>
                          </div>
                        }
                    
                    <h4>PDF Page Size</h4>
                    <div className="radio radio--small">
                      <label for="us_letter">
                        <input type="radio" name="pageSize" value="LETTER" onChange={(e) => setSize(e)} className="" id="us_letter" checked={pageSize === 'LETTER'}/>
                        <span className="radio-label">
                          <span className="radio-label-title">US Letter</span>
                        </span>
                      </label>
                    </div>
                    <div className="radio radio--small">
                      <label for="a4">
                        <input type="radio" name="pageSize" value="A4" onChange={(e) => setSize(e)} className="" id="a4" checked={pageSize === 'A4'}/>
                        <span className="radio-label">
                          <span className="radio-label-title">A4</span>
                        </span>
                      </label>
                    </div>


                    <div className="a-card a-card--normal">
                      <div className="a-card__paddings">
                        <div className="fieldset full-width">
                          <div className="fieldset__title">Corporate Email</div>
                          <div className={ pdfCorporateEmail ? "field field--medium field--filled" : "field field--medium"}>
                            <span className="fieldset__svg-icon"></span>
                            <label className="field__label">Corporate Email</label>
                            
                            <input disabled={submitted} id="modal-title" type="text" value={pdfCorporateEmail} onFocus={focus} onBlur={blur} onChange={(e) => validateEmail(e)} className="field__input" tabindex="4" maxlength="64" />

                            <div className="field__placeholder">Corporate Email</div>
                            <span className="field-state--success"></span>
                            <span className="field-state--close"></span>
                          </div>
                          <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                        </div>
                      </div>
                    </div>

                    <div className="a-card a-card--normal">
                      <div className="a-card__paddings">
                        <div className="fieldset full-width">
                          <div className="fieldset__title">Corporate Phone #</div>
                          <div className={ pdfCorporatePhone ? "field field--medium field--filled" : "field field--medium"}>
                            <span className="fieldset__svg-icon"></span>
                            <label className="field__label">Corporate Phone #</label>
                            
                            <input disabled={submitted} id="modal-title" type="text" value={pdfCorporatePhone} onFocus={focus} onBlur={blur} onChange={(e) => validatePhone(e)} className="field__input" tabindex="4" maxlength="64" />

                            <div className="field__placeholder">Corporate Phone #</div>
                            <span className="field-state--success"></span>
                            <span className="field-state--close"></span>
                          </div>
                          <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                        </div>
                      </div>
                    </div>

                    <div className="a-card a-card--normal">
                      <div className="a-card__paddings">
                        <div className="fieldset full-width">
                          <div className="fieldset__title">Invoice Number Label Override</div>
                          <div className={ invoiceNumberOverride ? "field field--medium field--filled" : "field field--medium"}>
                            <span className="fieldset__svg-icon"></span>
                            <label className="field__label">Invoice Number Label Override</label>
                            
                            <input disabled={submitted} id="modal-title" type="text" value={invoiceNumberOverride} onFocus={focus} onBlur={blur} onChange={(e) => validateInvoiceOverride(e)} className="field__input" tabindex="4" maxlength="64" />

                            <div className="field__placeholder">Invoice Number Label Override</div>
                            <span className="field-state--success"></span>
                            <span className="field-state--close"></span>
                          </div>
                          <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                        </div>
                      </div>
                    </div>

                    <div className="a-card a-card--normal">
                      <div className="a-card__paddings">
                        <div className="fieldset full-width">
                          <div className="fieldset__title">Purchase Order Label Override</div>
                          <div className={ purchaseOrderNumberOverride ? "field field--medium field--filled" : "field field--medium"}>
                            <span className="fieldset__svg-icon"></span>
                            <label className="field__label">Purchase Order Label Override</label>
                            
                            <input disabled={submitted} id="modal-title" type="text" value={purchaseOrderNumberOverride} onFocus={focus} onBlur={blur} onChange={(e) => validatePurchaseOrderOverride(e)} className="field__input" tabindex="4" maxlength="64" />

                            <div className="field__placeholder">Purchase Order Label Override</div>
                            <span className="field-state--success"></span>
                            <span className="field-state--close"></span>
                          </div>
                          <div className="field__error" aria-hidden="true" style={{display: 'none'}}></div>
                        </div>
                      </div>
                    </div>


                    <div className="a-card a-card--normal">
                      <div className="a-card__paddings">
                        <div className="iconable-block iconable-block--hide-in-mobile">
                          <div className="iconable-block__infographics">
                            <span className="iconable-block__icon">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="#189dee" viewBox="0 0 20 20" focusable='false'>
                                <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm5.71 8.11l-5.95 6.52c-.24.24-.56.37-.87.37-.32 0-.63-.12-.87-.37L4.7 11.55c-.48-.48-.48-1.28 0-1.77a1.21 1.21 0 011.73.01l2.46 2.19 5.08-5.64a1.22 1.22 0 011.73 0c.48.5.48 1.28.01 1.77z"/>
                              </svg>
                            </span>
                          </div>
                          <div className="iconable-block__content">
                            <div className="status-block">
                              <div className="status-block__central">
                                <div className="status-block__header">
                                  <span className="status-block__title">
                                    Include Authorization Line
                                  </span>
                                </div>
                                <div className="status-block__content">
                                  <p>
                                    Include authorization line. Include this line if you need to have physically signed purchase orders, and want a line for people to sign on.
                                  </p>
                                </div>
                              </div>
                              <div className="status-block__primary-action">
                                <label className="checkbox big">
                                  { authorizationLine && <input type="checkbox" checked="true" onClick={() => handleAuthLine()}/>}
                                  { !authorizationLine && <input type="checkbox" onClick={() => handleAuthLine()}/>}
                                  <div><div></div></div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>

                <button onClick={() => {throw new Error("Manually capture in Sentry");}}>.</button>

              </div>
            </div>
          </div>
        </div>
      </div>

      { showNewPaymentTermModal && 
        <NewPaymentTermModal
          payload={payload}
          showNewPaymentTermModal={showNewPaymentTermModal}
          setShowNewPaymentTermModal={setShowNewPaymentTermModal}
        />
      }

      { showEditPaymentTermModal && 
        <EditPaymentTermModal
          payload={payload}
          showEditPaymentTermModal={showEditPaymentTermModal}
          setShowEditPaymentTermModal={setShowEditPaymentTermModal}
          paymentTerm={activePaymentTerm}
        />
      }
      
      { showDisablePaymentTermModal &&
        <DisablePaymentTermModal
          payload={payload}
          showDisablePaymentTermModal={showDisablePaymentTermModal}
          setShowDisablePaymentTermModal={setShowDisablePaymentTermModal}
          paymentTerm={activePaymentTerm}
        />
      }


      { showNewPaymentMethodModal && 
        <NewPaymentMethodModal
          payload={payload}
          showNewPaymentMethodModal={showNewPaymentMethodModal}
          setShowNewPaymentMethodModal={setShowNewPaymentMethodModal}
        />
      }

      { showEditPaymentMethodModal && 
        <EditPaymentMethodModal
          payload={payload}
          showEditPaymentMethodModal={showEditPaymentMethodModal}
          setShowEditPaymentMethodModal={setShowEditPaymentMethodModal}
          paymentMethod={activePaymentMethod}
        />
      }
      
      { showDisablePaymentMethodModal &&
        <DisablePaymentMethodModal
          payload={payload}
          showDisablePaymentMethodModal={showDisablePaymentMethodModal}
          setShowDisablePaymentMethodModal={setShowDisablePaymentMethodModal}
          paymentMethod={activePaymentMethod}
        />
      }



      { showNewTaxSettingModal && 
        <NewTaxSettingModal
          payload={payload}
          showNewTaxSettingModal={showNewTaxSettingModal}
          setShowNewTaxSettingModal={setShowNewTaxSettingModal}
        />
      }

      { showEditTaxSettingModal && 
        <EditTaxSettingModal
          payload={payload}
          showEditTaxSettingModal={showEditTaxSettingModal}
          setShowEditTaxSettingModal={setShowEditTaxSettingModal}
          taxSetting={activeTaxSetting}
        />
      }
      
      { showDisableTaxSettingModal &&
        <DisableTaxSettingModal
          payload={payload}
          showDisableTaxSettingModal={showDisableTaxSettingModal}
          setShowDisableTaxSettingModal={setShowDisableTaxSettingModal}
          taxSetting={activeTaxSetting}
        />
      }

    </>
  )
}

const mapStateToProps = state => ({
  stores: state.stores,
  settings: state.settings,
  locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
  submitSettings: (payload, newSettings) => dispatch(updateSettings(payload, newSettings)),
  loadLocations: (payload) => dispatch(locationsIndex(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);